import { usePlatformStore } from "@platform/store";
import { DashboardAlertBanner } from "./DashboardAlertBanner";

export function DashboardAlertBannerContainer() {
  const alertMessage = usePlatformStore((s) => s.alertMessage);

  return <DashboardAlertBanner message={alertMessage} />;
}

export default DashboardAlertBannerContainer;


